import { apiService } from '../core/ApiService.js';
import { i18n } from '../utils/I18n.js';

export class AuthModal {
    constructor(onSuccess) {
        this.container = null;
        this.onSuccess = onSuccess; // 登录成功后的回调
        this.isLoginTab = true;
    }

    create() {
        if (document.getElementById('authModal')) return;

        const modal = document.createElement('div');
        modal.id = 'authModal';
        modal.innerHTML = `
            <div class="auth-modal-content">
                <button class="auth-close-btn">&times;</button>
                
                <div class="auth-tabs">
                    <button class="auth-tab active" data-tab="login" data-i18n="auth.login_tab">Login</button>
                    <button class="auth-tab" data-tab="register" data-i18n="auth.register_tab">Register</button>
                </div>

                <div class="auth-body">
                    <form id="authForm" class="auth-form">
                        <div class="form-group" id="usernameGroup" style="display: none;">
                            <label data-i18n="auth.username">Username</label>
                            <input type="text" name="username" data-i18n="auth.username_placeholder" placeholder="Your display name">
                        </div>
                        <div class="form-group">
                            <label data-i18n="auth.account">Email / Account</label>
                            <input type="text" name="account" data-i18n="auth.account_placeholder" placeholder="Enter your email" required>
                        </div>
                        <div class="form-group">
                            <label data-i18n="auth.password">Password</label>
                            <input type="password" name="password" data-i18n="auth.password_placeholder" placeholder="Enter password" required>
                        </div>
                        <div class="form-error" id="authError"></div>
                        <button type="submit" class="auth-submit-btn" data-i18n="auth.login_btn">Login</button>
                    </form>

                    <div class="auth-divider">
                        <span data-i18n="auth.or">OR</span>
                    </div>

                    <button type="button" id="googleOAuthBtn" class="google-oauth-btn">
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                        </svg>
                        <span data-i18n="auth.google_login">Sign in with Google</span>
                    </button>
                </div>
            </div>
        `;

        this._injectStyles();
        document.body.appendChild(modal);
        this.container = modal;

        this._bindEvents();
    }

    _injectStyles() {
        if (document.getElementById('auth-modal-styles')) return;
        const style = document.createElement('style');
        style.id = 'auth-modal-styles';
        style.textContent = `
            #authModal {
                position: fixed;
                top: 0; left: 0; width: 100%; height: 100%;
                background: rgba(0, 0, 0, 0.6);
                backdrop-filter: blur(5px);
                z-index: 3000;
                display: none;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transition: opacity 0.3s ease;
            }
            #authModal.visible {
                opacity: 1;
            }
            .auth-modal-content {
                background: #FFFFFF;
                width: 90%;
                max-width: 400px;
                border-radius: 20px;
                padding: 30px;
                position: relative;
                box-shadow: 0 10px 40px rgba(0,0,0,0.2);
                transform: translateY(20px);
                transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            }
            #authModal.visible .auth-modal-content {
                transform: translateY(0);
            }
            .auth-close-btn {
                position: absolute;
                top: 15px;
                right: 15px;
                background: none;
                border: none;
                font-size: 24px;
                color: #8B7355;
                cursor: pointer;
            }
            .auth-tabs {
                display: flex;
                margin-bottom: 24px;
                border-bottom: 1px solid #EEE;
            }
            .auth-tab {
                flex: 1;
                background: none;
                border: none;
                padding: 12px;
                font-family: inherit;
                font-size: 1.1rem;
                font-weight: 600;
                color: #B5A08E;
                cursor: pointer;
                transition: all 0.3s;
                border-bottom: 2px solid transparent;
            }
            .auth-tab.active {
                color: #A67C52;
                border-bottom-color: #A67C52;
            }
            .form-group {
                margin-bottom: 16px;
            }
            .form-group label {
                display: block;
                font-size: 0.9rem;
                color: #5D4E42;
                margin-bottom: 6px;
                font-weight: 500;
            }
            .form-group input {
                width: 100%;
                padding: 10px 14px;
                border: 1px solid #DDD;
                border-radius: 8px;
                font-family: inherit;
                font-size: 1rem;
                transition: border-color 0.3s;
            }
            .form-group input:focus {
                outline: none;
                border-color: #C9A77D;
            }
            .auth-submit-btn {
                width: 100%;
                padding: 12px;
                background: linear-gradient(135deg, #C9A77D, #A67C52);
                color: white;
                border: none;
                border-radius: 8px;
                font-size: 1rem;
                font-weight: 600;
                cursor: pointer;
                transition: opacity 0.3s;
            }
            .auth-submit-btn:hover {
                opacity: 0.9;
            }
            .auth-divider {
                display: flex;
                align-items: center;
                margin: 24px 0;
                color: #B5A08E;
                font-size: 0.85rem;
            }
            .auth-divider::before, .auth-divider::after {
                content: '';
                flex: 1;
                height: 1px;
                background: #EEE;
            }
            .auth-divider span {
                padding: 0 10px;
            }
            .form-error {
                color: #E07A6B;
                font-size: 0.9rem;
                margin-bottom: 12px;
                min-height: 1.2em;
                text-align: center;
            }
            .google-oauth-btn {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                padding: 12px 16px;
                background: #FFFFFF;
                border: 1px solid #DADCE0;
                border-radius: 8px;
                font-family: inherit;
                font-size: 0.95rem;
                font-weight: 500;
                color: #3C4043;
                cursor: pointer;
                transition: all 0.2s ease;
            }
            .google-oauth-btn:hover {
                background: #F8F9FA;
                border-color: #C6C9CC;
                box-shadow: 0 1px 3px rgba(60,64,67,0.15);
            }
        `;
        document.head.appendChild(style);
    }

    _bindEvents() {
        const closeBtn = this.container.querySelector('.auth-close-btn');
        closeBtn.onclick = () => this.hide();

        // Tabs
        const tabs = this.container.querySelectorAll('.auth-tab');
        tabs.forEach(tab => {
            tab.onclick = () => {
                this._switchTab(tab.dataset.tab);
            };
        });

        // Form Submit
        const form = document.getElementById('authForm');
        form.onsubmit = async (e) => {
            e.preventDefault();
            const formData = new FormData(form);
            const account = formData.get('account');
            const password = formData.get('password');
            const username = formData.get('username');

            const errorDiv = document.getElementById('authError');
            errorDiv.textContent = '';

            try {
                if (this.isLoginTab) {
                    await apiService.login(account, password);
                } else {
                    await apiService.register(username, account, password);
                }
                this.hide();
                if (this.onSuccess) this.onSuccess(apiService.getCurrentUser());
            } catch (err) {
                errorDiv.textContent = err.message;
            }
        };

        // Google OAuth redirect
        const googleBtn = this.container.querySelector('#googleOAuthBtn');
        if (googleBtn) {
            googleBtn.onclick = () => {
                apiService.startGoogleOAuth();
            };
        }
    }

    _switchTab(tabName) {
        this.isLoginTab = (tabName === 'login');
        const usernameGroup = document.getElementById('usernameGroup');
        const submitBtn = this.container.querySelector('.auth-submit-btn');
        const tabs = this.container.querySelectorAll('.auth-tab');

        tabs.forEach(t => t.classList.toggle('active', t.dataset.tab === tabName));

        if (this.isLoginTab) {
            usernameGroup.style.display = 'none';
            document.querySelector('input[name="username"]').required = false;
            submitBtn.textContent = i18n.t('auth.login_btn');
            submitBtn.setAttribute('data-i18n', 'auth.login_btn');
        } else {
            usernameGroup.style.display = 'block';
            document.querySelector('input[name="username"]').required = true;
            submitBtn.textContent = i18n.t('auth.register_btn');
            submitBtn.setAttribute('data-i18n', 'auth.register_btn');
        }

        this._resetForm();
    }

    _resetForm() {
        const form = document.getElementById('authForm');
        if (form) {
            form.reset();
        }
        const errorDiv = document.getElementById('authError');
        if (errorDiv) {
            errorDiv.textContent = '';
        }
    }

    show() {
        if (!this.container) this.create();

        // Always reset form when showing modal
        this._resetForm();
        this._switchTab('login');

        this.container.style.display = 'flex';
        // reflow
        this.container.offsetHeight;
        this.container.classList.add('visible');

        i18n.applyTranslations();
    }

    hide() {
        if (!this.container) return;
        this.container.classList.remove('visible');
        setTimeout(() => {
            this.container.style.display = 'none';
        }, 300);
    }
}
